import PropTypes from 'prop-types';

import Image from 'next/legacy/image';

import { ImageWrapper } from './styled';
import variants from './variants';
import types from './types';

const CustomImage = ({
  variant, minHeight, type, url, provider, alternativeText, innerRef, ...rest
}) => {
  const pathPrefix = provider === 'local' ? 'http://localhost:1337' : '';
  return (
    <ImageWrapper minHeight={minHeight} ref={innerRef}>
      <Image
        layout={type}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
        alt={alternativeText}
        src={pathPrefix + url}
      />
    </ImageWrapper>
  );
};

CustomImage.propTypes = {
  provider: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  minHeight: PropTypes.any,
  variant: PropTypes.oneOf(Object.values(variants)),
  url: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(types)).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  alternativeText: PropTypes.string.isRequired,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Object) }),
  ]),
};

CustomImage.defaultProps = {
  provider: '',
  minHeight: {},
  variant: variants.primary,
  width: undefined,
  height: undefined,
  innerRef: null,
};

export default CustomImage;
